import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FiPlus, FiTrash2, FiCheckSquare } from 'react-icons/fi'
import Select from "react-select";
import AsyncSelect from "react-select/async";


const PurchasingOrderFA = () => {

  const [items, setItems] = useState([
    { local_id: 1, drug_id: null, name: "", price: 0, qty: 0, total: 0, drugs: [] },
  ]);  
  const [distributors, setDistributors] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("Cash");
  const [description, setDescription] = useState("");
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isAgreed, setIsAgreed] = useState(false);
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const distributorOptions = distributors.map(d => ({ value: d.id, label: d.name }));
  const outletOptions = outlets.map(o => ({ value: o.id, label: o.name }));



  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedIdOutlet = localStorage.getItem("id_outlet");
    const storedRole = localStorage.getItem("role");
  
    console.log("LocalStorage - Token:", storedToken);
    console.log("LocalStorage - id_outlet:", storedIdOutlet);
    console.log("LocalStorage - Role:", storedRole);
  
    setToken(storedToken);
  
    if (storedRole === "manager" && storedIdOutlet) {
      setSelectedOutlet(storedIdOutlet);
    }
  
    loadDistributors();
    loadOutlets();
  }, []);

const loadDistributors = async (inputValue) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/distributor`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        per_page: 20,
        page: 1,
        order_by: "name",
        search: inputValue || "", // API mendukung pencarian
      },
    });
    return res.data?.data.map(d => ({ value: d.id, label: d.name })) || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

const loadOutlets = async (inputValue) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        per_page: 20,
        page: 1,
        order_by: "name",
        search: inputValue || "",
      },
    });
    return res.data?.data.map(o => ({ value: o.id, label: o.name })) || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

  const fetchDrugs = async (index, search = "") => {
    const role = localStorage.getItem("role");
  
    if (role !== "manager" && role !== "owner") {
      console.error("Hanya manager atau owner yang bisa mengakses data obat.");
      return;
    }
  
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/drug`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          per_page: 10,
          page: 1,
          order_by: "name",
          search,
        },
      });
      const newItems = [...items];
      newItems[index].drugs = res.data.data || [];
      setItems(newItems);
    } catch (err) {
      console.error("Failed to fetch drugs:", err.response?.data?.message || err.message);
    }
  };
  

  const handleSearchChange = (index, value) => {
    const newItems = [...items];
    newItems[index].name = value;
    setItems(newItems);
    fetchDrugs(index, value);
  };

  const handleQtyChange = (index, value) => {
    const newQty = Math.max(1, parseInt(value) || 0); // minimal qty = 1
    const newItems = [...items];
    newItems[index].qty = newQty;
    newItems[index].total = newQty * newItems[index].price;
    setItems(newItems);
  };
  
  const addItem = () => {
    setItems([...items, { id: items.length + 1, name: "", price: 0, qty: 0, total: 0, drugs: [] }]);
  };
  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const payload = {
      distributor_id: parseInt(selectedDistributor),
      outlet_id: parseInt(selectedOutlet),
      method: selectedMethod.toLowerCase(),
      description,
      total_amount: items.reduce((sum, item) => sum + item.total, 0),
      items: items.map((item) => ({
        id: item.id,
        price: item.price,
        qty: item.qty,
        subtotal: item.total,
      })),
    };
  
    console.log("Submitting payload:", payload);
  
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Response:", res.data);
      setShowSuccessModal(true); // show success popup
    } catch (err) {
      console.error("Failed to submit PO", err);
      console.error("Response data:", err.response?.data);
    }
  };
  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        navigate("/inventory/purchase-order");
      }, 2000); // redirect setelah 2 detik
      return () => clearTimeout(timer);
    }
  }, [showSuccessModal]);  
  const totalAmount = items.reduce((sum, item) => sum + item.total, 0);
  return (
       <div className="p-6 bg-green-50 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-700 mb-6">📦 Purchasing Order</h1>
    
      <div className="flex gap-6 flex-wrap">
        {/* Left Panel: Items */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex-1 min-w-[60%]">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-green-700 flex items-center gap-2">
              <FiCheckSquare /> Items
            </h2>
            <button
              onClick={addItem}
              className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition"
            >
              <FiPlus /> Add Item
            </button>
          </div>
    
          <table className="w-full border-collapse rounded-lg overflow-hidden shadow-sm">
            <thead className="bg-green-100 text-green-800">
              <tr>
                <th className="px-4 py-2 text-left"></th>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Price</th>
                <th className="px-4 py-2 text-left">Qty</th>
                <th className="px-4 py-2 text-left">Total</th>
                <th className="px-4 py-2 text-left"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index} className="odd:bg-white even:bg-gray-50 border-t">
                  <td className="px-4 py-2 text-green-600">
                    <FiCheckSquare />
                  </td>
                  <td className="px-4 py-2">
                    <input
                      type="text"
                      className="border p-2 rounded-md w-full focus:outline-green-400"
                      placeholder="Search Obat ..."
                      value={item.name}
                      onChange={(e) => handleSearchChange(index, e.target.value)}
                    />
                    <ul className="border mt-1 max-h-40 overflow-auto rounded-md shadow bg-white z-10 relative">
                      {item.drugs.map((drug) => (
                       <li
                       key={drug.id}
                       className="p-2 hover:bg-green-100 cursor-pointer text-sm"
                       onClick={() => {
                         const newItems = [...items];
                         newItems[index] = {
                           id: drug.id, 
                           name: drug.name,
                           price: drug.harga_beli,
                           qty: 0,
                           total: 0,
                           drugs: [], 
                         };
                         setItems(newItems);
                       }}
                     >
                       {drug.name} - Rp {drug.harga_beli.toLocaleString("id-ID")}
                     </li>
                     
                      ))}
                    </ul>
                  </td>
                  <td className="px-4 py-2 text-gray-700">Rp {item.price?.toLocaleString("id-ID")}</td>
                  <td className="px-4 py-2">
                    <input
                      type="number"
                      className="border p-2 rounded-md w-20"
                      value={item.qty}
                      onChange={(e) => {
                        const newItems = [...items];
                        const val = e.target.value;
                        newItems[index].qty = val === "" ? "" : parseInt(val) || 0;
                        newItems[index].total = (newItems[index].price || 0) * (parseInt(val) || 0);
                        setItems(newItems);
                      }}
                    />

                  </td>
                  <td className="px-4 py-2 text-green-700">Rp {item.total?.toLocaleString("id-ID")}</td>
                  <td className="px-4 py-2 text-red-500 cursor-pointer">
                    <FiTrash2 onClick={() => setItems(items.filter((_, i) => i !== index))} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    
        {/* Right Panel: PO Form */}
        <div className="bg-white p-6 rounded-2xl shadow-lg w-full md:w-1/3 min-w-[300px]">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">🧾 Detail Purchase Order</h2>
    
          <div className="space-y-4 text-sm">
          <div>
          <label className="block font-semibold text-gray-600 mb-1">Distributor</label>
         <AsyncSelect
  cacheOptions
  defaultOptions
  loadOptions={loadDistributors}
  onChange={(opt) => setSelectedDistributor(opt.value)}
  className="text-sm"
  isSearchable
/>
        </div>

        <div>
          <label className="block font-semibold text-gray-600 mb-1">Outlet</label>
         <AsyncSelect
  cacheOptions
  defaultOptions
  loadOptions={loadOutlets}
  onChange={(opt) => setSelectedOutlet(opt.value)}
  className="text-sm"
  isSearchable
/>
        </div>            
    
            <div>
              <label className="block font-semibold text-gray-600 mb-1">Payment Method</label>
              <select
                value={selectedMethod}
                onChange={(e) => setSelectedMethod(e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                <option value="">Select Method</option>
                <option value="Cash">Cash</option>
                <option value="Credit">Credit</option>
              </select>
            </div>
    
            <div>
              <label className="block font-semibold text-gray-600 mb-1">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full p-2 border rounded-md resize-none"
                rows={3}
              />
            </div>
    
            <div className="text-lg font-semibold text-gray-700">
              Total Amount:{' '}
              <span className="text-green-600">Rp {totalAmount.toLocaleString("id-ID")}</span>
            </div>
    
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={isAgreed}
                onChange={() => setIsAgreed(!isAgreed)}
                className="accent-green-600"
              />
              <span>Saya menyetujui Purchase Order ini</span>
            </div>
    
            <button
            onClick={handleSubmit}
            disabled={
              !selectedDistributor ||
              !selectedOutlet ||
              items.length === 0 ||
              items.some((item) => !item.name) // hanya cek nama
            }
            className={`w-full text-center py-2 px-4 rounded-md text-white font-semibold transition ${
              !selectedDistributor || !selectedOutlet || items.length === 0
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            Submit PO
          </button>
          </div>
        </div>
      </div>
      {showSuccessModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-xl p-6 shadow-lg text-center max-w-sm w-full">
      <h2 className="text-green-600 text-xl font-semibold mb-2">Berhasil!</h2>
      <p className="text-gray-700">Purchase Order berhasil dibuat.</p>
    </div>
  </div>
)}

    </div>
  );
};

export default PurchasingOrderFA;
